import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import styled, {css} from 'styled-components'

export const StyledCalendarNav = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-columns: auto 1fr auto;
        align-items: center;
        text-align: center;
        border-radius: 6px;
        color: ${palette.neutral['950']};
        background-color: ${palette.neutral['white']};
        border: 1px solid ${palette.neutral['200']};
    `
)

export const StyledCalendarMonthTitle = styled(Text)`
    text-transform: capitalize;
    cursor: pointer;
`

export const StyledCalendarNavMonthYearSelectorsGrid = styled(Flexbox)(
    () => css`
        display: grid;
        grid-template-columns: 1fr auto auto;
        align-items: center;
        & button {
            outline: none !important;
            box-shadow: none !important;
            white-space: nowrap;
            text-transform: capitalize;
        }
    `
)
